export default function getOrderShortId(orderId: string) {
  return '#' + orderId.substring(orderId.length - 6)
}
